import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import SwipeableBottomSheet from "react-swipeable-bottom-sheet";

import UBXButton from "./../../components/ubx/button";
import UBXTree from "./../../components/ubx/tree";
import UBXTreeItem from "./../../components/ubx/tree/item";

import FeedbackRatingModal from "./../common/modal/feedback-rating";

import { scrollToTop } from "./../../helpers/screen";
import { getPagePath } from "./../../helpers/system";

import SeekCapLogo from "./../common/logo";

export default class Form extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
        };
    }

    componentDidMount() {
        scrollToTop();
    }

    toggleBottomSheet(e) {
        if (e) e.preventDefault();
        this.setState({ open: !this.state.open });
    }
    /*
    toggleAside(e) {
        e.preventDefault();

        let { target } = e;

        if (target.tagName !== "A") {
            target = target.closest('a[href="#toggle-aside"]');
        }

        const aside = target.closest("aside");

        aside.classList.toggle("open");

        return false;
    }
*/
    renderHeaderNav() {
        const { backLink = false, headerMenu = [], onClick: onClickParent = false, data = false } = this.props;

        let headerNav = [];
        if (backLink) {
            const { text, to } = backLink;

            headerNav.push(
                <Link
                    key={"back"}
                    className={"back"}
                    to={to}
                    title={text}
                    onClick={(e) => {
                        return onClickParent ? onClickParent(e) : true;
                    }}
                >
                    {text}
                </Link>,
            );
        }

        if (headerMenu) {
            headerMenu.forEach((menuItem) => {
                const { text, to = false, onClick = false, config = {}, popover = false } = menuItem;

                let menuContent = false;

                if (to) {
                    menuContent = (
                        <Link
                            key={to}
                            to={to}
                            title={text}
                            onClick={(e) => {
                                return onClickParent ? onClickParent(e) : true;
                            }}
                        >
                            {text}
                        </Link>
                    );
                } else if (onClick) {
                    menuContent = (
                        <UBXButton key={text} onClick={onClick} title={text} {...config}>
                            {text}
                        </UBXButton>
                    );
                }

                if (menuContent) {
                    if (popover) {
                        const { title, content, shownInMobile = true } = popover;

                        const overlay = (
                            <Popover>
                                <Popover.Title>{title}</Popover.Title>
                                <Popover.Content>{content}</Popover.Content>
                            </Popover>
                        );

                        let show = false;
                        if (shownInMobile && window.document.body.offsetWidth < 768) {
                            show = true;
                        }

                        menuContent = (
                            <OverlayTrigger
                                trigger={["hover", "hover"]}
                                rootClose={true}
                                key={text}
                                placement={"bottom"}
                                overlay={overlay}
                                defaultShow={show}
                            >
                                {menuContent}
                            </OverlayTrigger>
                        );
                    }

                    headerNav.push(menuContent);
                }
            });
        }

        if (headerNav.length > 0) {
            headerNav = <nav>{headerNav}</nav>;
        }

        let link = getPagePath("Dashboard");
        if (data) {
            const { loan = false } = data;
            if (loan) {
                const { property = false } = loan;
                if (property) {
                    link = getPagePath("MotorcyclesDashboard");
                }
            }
        }

        return (
            <header>
                <SeekCapLogo className="d-block d-md-none" link={link} />
                {headerNav}
            </header>
        );
    }

    renderFormNav() {
        const { open } = this.state;
        const {
            headerTitle = false,
            onClick = false,
            sideMenu = false,
            sideMenuActive = [],
            sideMenuLink = "",
            sideMenuOnClick = false,
            data = false,
            type = false,
        } = this.props;
        const { loan } = data || {};
        const { property } = loan || {};

        const [activeSection, activeSubSection] = sideMenuActive;

        let formNavTitle = [];
        if (sideMenu) {
            if (activeSection) {
                const { title, items: subMenuItems } = sideMenu[activeSection] || {};

                formNavTitle.push(<span key={title}>{title}</span>);

                if (activeSubSection) {
                    const { title: subMenuTitle } = subMenuItems[activeSubSection] || {};
                    formNavTitle.push(<span key={subMenuTitle}>{subMenuTitle}</span>);
                }
            }
        }

        let link = getPagePath("Dashboard");
        if (property) {
            link = getPagePath("MotorcyclesDashboard");
        }

        let renderHeaderTitle = "";
        if (headerTitle) {
            renderHeaderTitle = <h1 title={headerTitle}>{headerTitle}</h1>;
        }

        return (
            <Fragment>
                <aside>
                    <div className="form-aside-container">
                        <SeekCapLogo type={type} darkmode={true} className="d-none d-md-block" link={link} onClick={onClick} />
                        {renderHeaderTitle}
                        {this.renderMenu(sideMenuLink, sideMenu, sideMenuActive, sideMenuOnClick)}
                    </div>
                </aside>
                <div className="form-aside-swipe d-md-none">
                    <SwipeableBottomSheet
                        overflowHeight={64}
                        shadowTip={false}
                        topShadow={false}
                        overlay={false}
                        open={open}
                        marginTop={72}
                        fullScreen={true}
                        onChange={() => this.toggleBottomSheet()}
                    >
                        <div className="swipe-content">
                            <a href="#toggle-aside" onClick={(e) => this.toggleBottomSheet(e)}>
                                <hr />
                                <strong>{formNavTitle}</strong>
                            </a>
                            <div className="form-aside-container">
                                {/*<SeekCapLogo darkmode={true} className="d-none d-md-block" onClick={onClick} />*/}
                                {renderHeaderTitle}
                                {this.renderMenu(sideMenuLink, sideMenu, sideMenuActive, sideMenuOnClick)}
                            </div>
                        </div>
                    </SwipeableBottomSheet>
                </div>
            </Fragment>
        );
    }

    renderMenu(sideMenuLink, structure, sideMenuActive, sideMenuOnClick = false) {
        const { type } = this.props;
        const [activeSection, activeSubSection] = sideMenuActive;

        let renderedMenu = "";
        let menuItems = [];
        if (structure) {
            for (let menuCode in structure) {
                const {
                    title,
                    items = {},
                    locked = false,
                    enabled = true,
                    hide = false,
                    incomplete = false,
                    complete = false,
                    disabled = false,
                    resubmit = 0,
                } = structure[menuCode];
                let menuLink = [sideMenuLink, menuCode];

                if (enabled) {
                    if (!hide && !disabled) {
                        let status = "";
                        let action = 0;

                        if (locked) {
                            status = "locked";
                        } else if (resubmit > 0) {
                            status = "resubmit";
                            action = resubmit;
                        } else if (incomplete) {
                            status = "incomplete";
                        } else if (complete) {
                            status = "done";
                        }

                        if (JSON.stringify(items) !== "{}") {
                            let subMenuItems = [];
                            let subMenuHasActive = false;
                            for (let subMenuCode in items) {
                                const {
                                    title: subMenuTitle,
                                    locked = false,
                                    enabled = true,
                                    hide = false,
                                    incomplete = false,
                                    complete = false,
                                    disabled = false,
                                    resubmit = 0,
                                } = items[subMenuCode];
                                menuLink[2] = subMenuCode;

                                if (enabled) {
                                    if (!hide && !disabled) {
                                        if (activeSubSection === subMenuCode) {
                                            subMenuHasActive = true;
                                        }

                                        let subMenuStatus = "";
                                        let subMenuAction = 0;
                                        if (locked) {
                                            subMenuStatus = "locked";
                                        } else if (resubmit > 0) {
                                            subMenuStatus = "resubmit";
                                            subMenuAction = resubmit;
                                        } else if (incomplete) {
                                            subMenuStatus = "incomplete";
                                            subMenuHasActive = true;
                                        } else if (complete) {
                                            subMenuStatus = "done";
                                        }

                                        subMenuItems.push(
                                            <UBXTreeItem
                                                id={subMenuCode}
                                                key={subMenuCode}
                                                link={`/${menuLink.join("/")}`}
                                                label={subMenuTitle}
                                                active={activeSubSection === subMenuCode}
                                                action={subMenuAction}
                                                status={subMenuStatus}
                                                onClick={sideMenuOnClick}
                                                type={type}
                                            />,
                                        );
                                    }
                                }
                            }

                            if (subMenuItems.length > 0) {
                                menuItems.push(
                                    <UBXTree
                                        key={menuCode}
                                        id={menuCode}
                                        title={title}
                                        collapsible={true}
                                        collapsed={!subMenuHasActive}
                                        status={status}
                                        type={type}
                                    >
                                        {subMenuItems}
                                    </UBXTree>,
                                );
                            }
                        } else {
                            if (enabled) {
                                if (!hide && !disabled) {
                                    menuItems.push(
                                        <UBXTreeItem
                                            id={menuCode}
                                            key={menuCode}
                                            link={`/${menuLink.join("/")}`}
                                            label={title}
                                            active={activeSection === menuCode}
                                            status={status}
                                            onClick={sideMenuOnClick}
                                            action={action}
                                            type={type}
                                        />,
                                    );
                                }
                            }
                        }
                    }
                }
            }
        }
        if (menuItems.length > 0) {
            renderedMenu = <UBXTree type={type} className="form-nav">{menuItems}</UBXTree>;
        }

        return renderedMenu;
    }

    render() {
        const { id, data = {}, sideMenu = {}, sideMenuActive = [], children = "", type = false } = this.props;

        let { className = [] } = this.props;

        if (!(className instanceof Array)) {
            className = [className];
        }
        className.unshift("layout-form");

        if (type) {
            className.push(type);
        }

        return (
            <div id={id} className={className.join(" ")}>
                <div id="page-top"></div>
                <div className="form-container">
                    {this.renderHeaderNav()}
                    <main>
                        {this.renderFormNav(sideMenu, sideMenuActive)}
                        <section className="form-content-container">{children}</section>
                        <FeedbackRatingModal page="LoanApplication" data={data} />
                    </main>
                </div>
            </div>
        );
    }
}
